import { FormLabelClassKey } from '@material-ui/core/FormLabel';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const THDFormLabelStyles: Partial<
  Record<FormLabelClassKey, CSSProperties>
> = {
  root: {
    paddingBottom: '5px',
    color: '#212120',
    '&$focused': {
      color: '#212120',
    },
  },
  /* Styles applied to the root element if `focused={true}`. */
  focused: {},
  /* Styles applied to the root element if `disabled={true}`. */
  disabled: {},
  /* Styles applied to the root element if `error={true}`. */
  error: {},
  /* Styles applied to the root element if `filled={true}`. */
  filled: {},
  /* Styles applied to the root element if `required={true}`. */
  required: {},
};
